(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["um-charity-banner"] && !Shopify.designMode) return;
  try {
    (function () {
    function formatFR(n) {
      return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    function initCounter(el) {
      var valueEl = el.querySelector('.charity-counter__value');
      if (!valueEl) return;
      var count = parseInt(el.dataset.start, 10) || 512;
      valueEl.textContent = formatFR(count);

      function bump() {
        count += 1;
        valueEl.textContent = formatFR(count);
        valueEl.classList.remove('charity-counter__value--bump');
        void valueEl.offsetWidth;
        valueEl.classList.add('charity-counter__value--bump');
        schedule();
      }

      function schedule() {
        var delay = Math.floor(Math.random() * 7000) + 6000;
        setTimeout(bump, delay);
      }

      schedule();
    }

    function run() {
      document.querySelectorAll('[data-charity-counter]').forEach(initCounter);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
